<template>
  <div class="labels">
    <div class="value-drivers">
      <div class="moat-logo"><div class="moat-logo-header align-right pt-3">Historical Examples Only</div></div>
      <div></div>
    </div>
    <div class="expectations">
      <div class="row no-gutters">
        <div class="column-header col-6">Expectations</div>
        <div class="expectations-column-header col-6">
          <div><span>Importance Rank</span></div>
          <div><span>Intensity Rank</span></div>
        </div>
      </div>
      <div class="row no-gutters">
        <div class="column-header col-6"></div>
        <div class="expectations-column-header col-6">
          <div><span>Dissonance Rank</span></div>
        </div>
      </div>
    </div>
    <div class="performance-assessment">
      <div class="column-header">Performance Assessment</div>
      <div class="performance-assessment-column-header row no-gutters">
        <div class="col-6 pl-1 pr-1">
          <div class="performance-assessment-column-section-header">GAP Group Sizes</div>
          <div>
            <span :class="getGapGroupClass(0)">Smallest 1/3<sup>rd</sup></span>
          </div>
          <div>
            <span :class="getGapGroupClass(1)">Next Tier</span>
          </div>
          <div>
            <span :class="getGapGroupClass(2)">Bottom Tier</span>
          </div>
        </div>
        <div class="col-6">
          <div class="performance-assessment-column-section-header">Willingness to Pay</div>
          <div>
            <span :class="getPricingPowerClass(0)">Highest 1/3<sup>rd</sup></span>
          </div>
          <div><span :class="getPricingPowerClass(1)">Next Tier</span></div>
          <div><span :class="getPricingPowerClass(2)">Bottom Tier</span></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "MoatMapLabels",
  mixins: [],
  components: {},
  data() {
    return {};
  },
  props: {
    useAltColors: {
      type: Boolean,
      default: false
    }
  },
  computed: {},
  mounted() {},
  created() {},
  methods: {
    getPricingPowerClass: function(index) {
      let pricingPowerClass = "color-pricing-power-tier-" + (index + 1);
      return pricingPowerClass;
    },
    getGapGroupClass: function(index) {
      let gapGroupClass = this.useAltColors ? "alt-" : "";
      gapGroupClass += "gap-group-tier-" + (index + 1);
      return gapGroupClass;
    }
  },
  watch: {}
};
</script>
